import * as Cesium from 'cesium';
import CONSTANTS from "../constants";
import $ from 'jquery';
import {findPointDetails, getChannelrecordNew} from "@/api/BoxData.js";

var MapUtil={

    /**
     * 初始化视图位置
     */
    initView(){
        const angleView=CONSTANTS.initViewConfig;
        window.gisViewer&&this.flyTo(angleView.longitude,angleView.latitude,angleView.height,angleView.heading,angleView.pitch);
        // let viewer = window.gisViewer;
        // viewer && viewer.scene && viewer.scene.camera && viewer.scene.camera.setView({
        //     destination: new Cesium.Cartesian3.fromDegrees(longitude, latitude, angleView.height),
        //     orientation: {
        //         heading: angleView.heading?Cesium.Math.toRadians(angleView.heading): viewer.scene.camera.heading,// 方向
        //         pitch: angleView.pitch?Cesium.Math.toRadians(angleView.pitch): viewer.scene.camera.pitch,// 倾斜角度
        //         roll: angleView.roll?angleView.roll: viewer.scene.camera.roll
        //     }
        // });
    },

    /**
     * 设置冒泡
     * @param {*} overlay
     */
    setOverlay(overlay){
        this.overlay=overlay;
    },

    /**
     * 关闭冒泡
     */
    closeOverlay(){
        this.overlay&&this.overlay.close();
    },
    /**
     * 打开冒泡弹框
     */
    openOverlay(entity){
        if(entity.attributes&&entity.attributes.layerName){
            $('#popupInfo').html(this.getOverlayContent(entity.attributes));
            $('.leaflet-popup-close-button').click(function () {//关闭
                MapUtil.closeOverlay();
            });
            if(this.overlay){
                this.overlay.setPosition(Cesium.Cartesian3.fromDegrees(Number(entity.attributes.longitude), Number(entity.attributes.latitude),CONSTANTS.ALTITUDE));
                this.overlay.show();
            }
        }
    },

    /**
     * 冒泡信息框内容处理
     * layerName是分类
     * @param {*} data
     */
    getOverlayContent(attributes){
        let content="";
        let bottomBtn='<div class="info-bottom" style="position: relative; top: -9px; margin: 0px auto;"><img style="margin-left: 152px;margin-bottom: -24px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAMAAADHqI+lAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjNCMTZENDU2NkNEMTExRUFCNTNFOTdERjU1MEJGOEVFIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjNCMTZENDU3NkNEMTExRUFCNTNFOTdERjU1MEJGOEVFIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6M0IxNkQ0NTQ2Q0QxMTFFQUI1M0U5N0RGNTUwQkY4RUUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6M0IxNkQ0NTU2Q0QxMTFFQUI1M0U5N0RGNTUwQkY4RUUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7jIeW+AAAAD1BMVEV4eHi7u7u6urq5ubn////udRiHAAAABXRSTlP/////APu2DlMAAAA0SURBVHjaVMjJDQAwCMRADvdfc7IhCOGfx9JWaSxJDGI+EIzcf9CiL8D1zoCkvgH/zxFgAC97AP+bBgXCAAAAAElFTkSuQmCC"></div>';
        switch (attributes.layerName) {
            case CONSTANTS.LAYER.WORKER://工作员
                content=`<div class="info-middle" style="width: 340px;"><div><span>工号：${attributes.empNo}</span><br>
                            <span> <button style="padding: 3px 0" type="text" onclick="window.workerCheckDetail('${attributes.deviceNo}')">详细信息</button></span><br>
                            <span><button style="padding: 3px 0" onclick="window.workerCheckHistory('${attributes.deviceNo}')" type="text">历史轨迹</button></span></div><div>`;
                break;
            case CONSTANTS.LAYER.FOURCOLOR://四色图
                content=`<div class="info-middle" style="width: 340px;"><div>
                            <span>区域名称：${attributes.name}</span><br/>
                            <span>风险等级：${attributes.riskLevelStr}</span><br/>
                            <span> <button style="padding: 3px 0" type="text" onclick="window.boxCheckDetail(${attributes.id})">详细信息</button></span>
                         </div><div>`;
                break;
            case CONSTANTS.LAYER.CAMERA://摄像头
                content=`<div class="info-middle" style="width: 340px;"><div>
                            <span>名称：${attributes.name}</span><br/>
                            <span> <button style="padding: 3px 0" type="text" onclick="window.openVideo('${attributes.name}','${attributes.monitoringUrl}')">打开视频监控</button></span>
                         </div><div>`;
                break;
            case CONSTANTS.LAYER.DEVICE://设备
                content=`<div class="info-middle" style="width: 550px;background-color: #36455C;">
                     <div style="margin-top: 8px;float:left;width: 220px;">
                        <br>
                        <span>探头信息</span><br><br>
                        <span>   状态：${attributes.type==0?'正常':'异常'}</span><br>
                        <span>   实时值：${attributes.value} ${attributes.unit}</span>
                     </div>
                     <div style="margin-top: 8px;">
                         <table border="0" cellspacing="0" cellpadding="0" width="320" style="padding-top: 50px;padding-bottom: 20px;">
                            <tr style="height: 40px"><td style="border: 1px solid #465773;background-color: #253D61;width: 30%;">监测点ID：</td><td style="border: 1px solid #465773;background-color: #20304A;">${attributes.tagId}</td></tr>
                            <tr style="height: 40px"><td style="border: 1px solid #465773;background-color: #253D61;">监测点名称：</td><td style="border: 1px solid #465773;background-color: #20304A;">${attributes.tagName}</td></tr>
                            <tr style="height: 40px"><td style="border: 1px solid #465773;background-color: #253D61;">更新时间：</td><td style="border: 1px solid #465773;background-color: #20304A;">${attributes.updateTime}</td></tr>
                            <tr style="height: 40px"><td style="border: 1px solid #465773;background-color: #253D61;">报警状态：</td><td style="border: 1px solid #465773;background-color: #20304A;">${attributes.type==0?'正常':'异常'}</td></tr>
                         </table>
                     </div>
                </div>`;
                break;
            default:
                content=`<div class="info-middle"><div>
                        <span>设施名称：${attributes.assetName}</span><br><span>管理单位：${attributes.custody}</span>`;
        }
        return `
                    <div class="bottom-center amap-info-contentContainer">
                        <a class="leaflet-popup-close-button" href="javascript:void(0)" style="right: 10px;position: absolute;">×</a>
                        <div class="custom-info input-card content-window-card" style="background-color: rgba(0, 0, 0, 0.53); color: white; border-radius: 5px; border: none;">
                            ${content}
                        </div>
                    </div>
                    ${bottomBtn}
                `;
    },
    /**
     * 添加图层
     * @param {*} layer
     */
    addLayer(layer){
        if(!this.layerMap){
            this.layerMap=new Map();
        }
        let name=layer.layerName || layer.get("layerName");
        this.layerMap.set(name,layer);
    },
    /**
     * 获取图层
     * @param {*} name
     */
    getLayerByName(name){
        if(this.layerMap){
            return this.layerMap.get(name);
        }
        return null;
    },

    /**
     * 删除图层
     * @param {*} layer
     */
    removeLayer(layer){
        let name=layer.layerName || layer.get("layerName");
        this.layerMap.delete(name);
        window.gisViewer.dataSources.remove(layer.dataSource);
    },


    /**
     * 加载模型
     * @param {*} modelInfo id=geokey,name,address,token,companyId
     * let geoKey = temp[0];//geoKey=id
     * let token = temp[1];//token
     * let companyId = temp[2];//companyId
     * let address = temp[3];
     */
    change3DModel(modelInfo){
        let self=this;
        let tileset = window.gisViewer._tilesetModels.filter(obj=> obj._id === modelInfo.id);
        if(tileset.length === 0){//判断是不是存在
          const obj = {
            id: modelInfo.id,
            name: modelInfo.name,
            key:modelInfo.key,
            type:modelInfo.type||'tileset',
            url: "http://"+modelInfo.address+"/assets/"+ modelInfo.id+"/tileset.json",
            authorization: {
              token: modelInfo.token,
              companyId: modelInfo.companyId
            }
          }
          self.gisViewer.addTileset(obj);
        }else{
          self.gisViewer.flyTo(tileset[0]);
        }
    },

    /**
     * 通过id获取模型
     * @param {*} id
     */
    getModelById(id){
        let tileset = window.gisViewer._tilesetModels.filter(obj=> obj._id === id);
        if(tileset.length === 0){
            return tileset[0];
        }
        return null;
    },

    /**
     * camera飞行到指定坐标与高度
     * @param {*} lon
     * @param {*} lat
     * @param {*} alt
     * @param {*} heading 指向
     * @param {*} pitch 视角
     */
    flyTo(lon, lat,alt=500,heading=0.0,pitch=-60){
        //定位
        window.gisViewer.viewer.camera.flyTo({
          destination : Cesium.Cartesian3.fromDegrees(Number(lon), Number(lat),Number(alt)),
          orientation : {
            heading : Cesium.Math.toRadians(heading),// 指向
            pitch : Cesium.Math.toRadians(pitch),// 视角
            roll : 0.0
          }
        });
    },

    /**
     * 飞行到指定实体
     * @param {*} entity
     * @param {*} pitch  视角
     * @param {*} range 距中心的距离，以米为单位
     */
    flyToByEntity(entity,pitch=-90.0,range=0){
        if(entity){
            window.gisViewer.viewer.flyTo(entity, {
                duration: 3,
                offset: new Cesium.HeadingPitchRange(0.0, Cesium.Math.toRadians(pitch),range)
            });
        }
    },

    /**
     * 高亮实体
     * @param {*} entity
     */
    highLightByEntity(entity){
        if(entity&&entity.attributes){
            switch (entity.attributes.layerName) {
                case CONSTANTS.LAYER.PATROLASSET+"_road"://巡查道路设施
                    entity.polyline.width=entity.attributes.highLightStyle.lineWidth||5;
                    entity.polyline.material.color=Cesium.Color.fromCssColorString(entity.attributes.highLightStyle.strokeStyle);
                    break;
                case CONSTANTS.LAYER.ASSET+"_road"://资产道路设施
                    entity.polyline.width=entity.attributes.highLightStyle.lineWidth||5;
                    entity.polyline.material.color=Cesium.Color.fromCssColorString(entity.attributes.highLightStyle.strokeStyle);
                    break;
                default:

            }
            this.highlightEntity=entity;
        }
    },


    /**
     * 取消高亮
     */
    cancelHighLight(){
        if(this.highlightEntity){
            if(this.highlightEntity.attributes){
                switch (this.highlightEntity.attributes.layerName) {
                    case CONSTANTS.LAYER.PATROLASSET+"_road"://巡查道路设施
                        this.highlightEntity.polyline.width=this.highlightEntity.attributes.normalStyle.lineWidth||5;
                        this.highlightEntity.polyline.material.color=Cesium.Color.fromCssColorString(this.highlightEntity.attributes.normalStyle.strokeStyle);
                        break;
                    case CONSTANTS.LAYER.ASSET+"_road"://资产道路设施
                        this.highlightEntity.polyline.width=this.highlightEntity.attributes.normalStyle.lineWidth||5;
                        this.highlightEntity.polyline.material.color=Cesium.Color.fromCssColorString(this.highlightEntity.attributes.normalStyle.strokeStyle);
                        break;
                    default:

                }
                this.highlightEntity=null;
            }
        }
    },

  /**
   * 获取Cartesian3点
   * @param lng
   * @param lat
   * @returns {Cartesian3}
   */
    getPosition(lng,lat){
      let position=Cesium.Cartesian3.fromDegrees(Number(lng),Number(lat),CONSTANTS.ALTITUDE);//高度单位：米
      let entity =new Cesium.Entity({
          id : Math.random(),
          position :position
        });
        let position_= window.gisViewer.scene.clampToHeight(position, [entity]);
        if(position_){
          let cartographic=Cesium.Cartographic.fromCartesian(position_);
          if(cartographic.height>0){
            position=Cesium.Cartesian3.fromDegrees(Number(lng), Number(lat),cartographic.height+0.5);//3dtiles模型上高度加0.5米
          }
        }
        return position;
    },

    /**
     * 4326坐标下米转度
     */
    changeMtoD:function(metre){
        return Number(metre) / (2 * Math.PI * 6371004)*360;
    },

    /**
     * 4326坐标下度转米
     */
    changeDtoM:function(d){
        return Number(d) * Math.PI * 6371004/360;
    },
    /**
     * 计算两点的距离  返回：dis 单位:米
     * @param {*} coords1 [lon,lat]
     * @param {*} coords2 [lon,lat]
     * return dis 单位:米
     */
    distance:function (coords1,coords2){
        var lineString=new ol.geom.LineString([coords1,coords2])
        var distance = ol.Sphere.getLength(lineString,{projection:SMAP.projCode});
        return Number(distance.toFixed(2));
    },
    /**
     * 根据feature返回feature JSON对象
     * @param {*} feature
     */
    getFeatureInfo:function(feature){
        var geometry=feature.getGeometry();
        var geomType=geometry.getType();
        var geom,featureStyle;
        if(geomType==="LineString"||geomType==="Polygon"){
            var points=[];
            if(geomType==="LineString"){
                geom=geometry.getCoordinates();
            }else{
                geom=geometry.getCoordinates()[0];
            }
            for(var j=0;j<geom.length;j++){
                points.push(this.toLngLat(geom[j][0],geom[j][1]));
            }
            geom=points.toString();
        }else if(geomType==="Circle"){
            var center=geometry.getCenter();
            center=this.toLngLat(center[0],center[1]);
            var radius=geometry.getRadius().toFixed(2);
            geom=center.toString()+","+radius;

        }else if(geomType==="Point"){
            geom=geometry.getCoordinates();
            geom=this.toLngLat(geom[0],geom[1]).toString();
        }
        var style=feature.getProperties();
        featureStyle={
            stroke:{
                color:style.strokeColor||'rgba(53,163,255,1)',
                width:style.strokeWidth||3,
                opacity:style.opacity||0.3,
                lineDash:style.lineDash||[]
            },
            fill:{
                color:style.fillColor||'rgba(53,163,225,0.2)'
            },
            bufferWidth:style.bufferWidth||0
        }
        return {
            geomType:geomType,
            geom:geom,
            featureStyle:JSON.stringify(featureStyle)
        };
    },
    /**
     * 根据数据和类型返回geomtry对象
     * @param {*} geomStr
     * @param {*} type
     */
    getGeometryByGeomType:function(geomStr,type){
        var geometry=null;
        var geomCoordArr=geomStr&&geomStr.split(",");
        if(type==="Point"){
            geometry=new ol.geom.Point([Number(geomCoordArr[0]),Number(geomCoordArr[1])]);
        }else if(type==="LineString"){
            var points=[];
            for(var j=0,length=geomCoordArr.length;j<length-1;j+=2){
                points.push([Number(geomCoordArr[j]),Number(geomCoordArr[j+1])]);
            }
            geometry=new ol.geom.LineString(points);
        }else if(type==="Circle"){
            var center=[Number(geomCoordArr[0]),Number(geomCoordArr[1])];
            var radius=this.changeMtoD(Number(geomCoordArr[2]));
            geometry=new ol.geom.Circle(center,radius);
        }else if(type==="Box"||"Polygon"){
            if(geomCoordArr.length % 2 !== 0){
                return ;
            }
            var points=[];
            for(var j=0,length=geomCoordArr.length;j<length-1;j+=2){
                points.push([Number(geomCoordArr[j]),Number(geomCoordArr[j+1])]);
            }
            geometry=new ol.geom.Polygon(points);
        }
        return geometry;
    }
}
export default MapUtil;
